import api from './api';

interface Role {
  id: number;
  industry: number;
  name: string;
  created_at: string;
  updated_at: string;
}

interface CreateRoleData {
  industry: number;
  name: string;
}

export const listRoles = async (industryId: number): Promise<Role[]> => {
  const response = await api.get(`roles/?industry=${industryId}`);
  return response.data;
};

export const createRole = async (data: CreateRoleData): Promise<Role> => {
  const response = await api.post(`roles/`, data);
  return response.data;
};

export const updateRole = async (id: number, data: Partial<CreateRoleData>): Promise<Role> => {
  const response = await api.patch(`roles/${id}/`, data);
  return response.data;
};

export const deleteRole = async (id: number): Promise<void> => {
  await api.delete(`roles/${id}/`);
};